import clsx from 'clsx';
import { Heading, Paragraph } from '@hungryroot/ramen';
import { type useDetectChanges } from '../useDetectChanges';
import { type useFoodFeedbackModal } from '../useFoodFeedbackModal';
import {
  type RatablePairingItem,
  type RatableProductItem,
} from '../useRatableItems';
import { RatableListItem } from './RatableListItem';

import styles from './RatableContent.module.css';
import sharedStyles from '../shared.module.css';

type RatableProductsContentProps = {
  items:
    | ReturnType<typeof useFoodFeedbackModal>['products']
    | ReturnType<typeof useFoodFeedbackModal>['pairings'];
  visible: boolean;
  onRating: ({
    prevValue,
    newValue,
  }: {
    prevValue: boolean | null;
    newValue: boolean | null;
    item: RatablePairingItem | RatableProductItem;
  }) => void;
  heading: string;
  intersectionRef: (node?: Element | null) => void;
  changeDetection: ReturnType<typeof useDetectChanges>;
  testId: string;
};

export function RatableContent(props: RatableProductsContentProps) {
  const {
    items,
    heading,
    visible,
    onRating,
    intersectionRef,
    changeDetection,
    testId,
  } = props;

  return (
    <div
      className={clsx(sharedStyles['visibility-transition'], styles.content)}
      data-visible={visible || null}
      data-testid={testId}
    >
      <div ref={intersectionRef} />
      <div className={styles['content-text-container']}>
        <Heading
          className={styles['content-text-container-heading']}
          variant="H1Alt"
        >
          {heading}
        </Heading>
        <Paragraph variant="body">
          This will help build better carts in the future.
        </Paragraph>
      </div>
      <div className={styles['ratable-list-container']}>
        {items.map((item) => (
          <RatableListItem
            key={`${item.name}-${item.orderNumber}-${item.type}`}
            onRating={(prevValue, newValue) => {
              onRating({ prevValue, newValue, item });
            }}
            item={item}
            changeDetection={changeDetection}
          />
        ))}
      </div>
    </div>
  );
}
